export const dropAction = (node: HTMLElement, enable: boolean) => {
  ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
    node.addEventListener(
      eventName,
      e => {
        e.preventDefault();
        e.stopPropagation();
      },
      false
    );
  });

  if (!enable) return;

  ['dragenter', 'dragover'].forEach(eventName => {
    node.addEventListener(
      eventName,
      (ev: any) => {
        ev.dataTransfer.dropEffect = 'copy';
        node.dispatchEvent(new CustomEvent('highlight'));
      },
      false
    );
  });

  ['dragleave', 'drop'].forEach(eventName => {
    node.addEventListener(
      eventName,
      () => {
        node.dispatchEvent(new CustomEvent('unhighlight'));
      },
      false
    );
  });

  node.addEventListener(
    'drop',
    e => {
      node.dispatchEvent(new CustomEvent('dropped', { detail: e.dataTransfer.files }));
    },
    false
  );
};
